<script setup>
import {reactive, onMounted, onUnmounted, computed} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

import PDFDocument from '@/StandaloneJS/pdfkit.standalone'
import blobStream from "blob-stream";
import {QuillEditor} from "@vueup/vue-quill";

const compName = 'TimelineComponent';

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const data = reactive({
  xactid: null,
  symbilityid: null,
  thirdPartyName: '',
  ALL_FILTERS: ["note", "message", "task", "generic", "file", "history"],
  currentUser: '',
  selectedFilters: ["note", "message", "task", "generic", "history"],
  timelineData: [],
  notes: [],
  notesSelected: false,
  show: [],
  openAdditionalNoteForm: false,
  originalFileName: '',
  // dialogNote: false,
  // dialogTask: false,
  clientTask: null,
  clientTaskInfo: null,
  clientTaskId: null,
  clientTaskCreatedAt: null,
  /* Used for sending Notes/Tasks to third party (xact, symbility) */
  thirdPartyNoteTitle: null,
  thirdPartyNoteId: null,
  thirdPartyNoteAI: null,
  thirdPartyNoteCreatedBy: null,
  thirdPartyNoteCreatedAt: null,
  thirdPartyTask: null,
  thirdPartyTaskInfo: null,
  thirdPartyTaskCreatedBy: null,
  thirdPartyTaskCreatedAt: null,
  thirdPartyTaskId: null,
  thirdPartyMessage: null,
  thirdPartyMessageSentTo: null,
  thirdPartyMessageSentFrom: null,
  thirdPartyMessageId: null,
  thirdPartyMessageCreatedAt: null,
  loading: false,
  loadingButton: false,
  loadingDelete: false,
});

const a = document.createElement('a')
document.body.appendChild(a)
a.style = "display: none";

const sendToThirdParty = (item) => {
  if(item.type === 'note'){
    if (typeof item.note === 'string' && item.note.length > 0 && item.note !== null) {
      // Remove formatting for note
      let note = item.note;

      note = note.replace(/<\/?[^>]+(>|$)/g, '');
      note = note.replace(/nbsp;/g, '');
      note = note.replace(/amp;nbsp;/g, '');
      note = note.replace(/amp;ndash;/g, '');
      note = note.replace(/amp;gt;/g, '');
      note = note.replace(/amp;lt;/g, '');
      note = note.replace(/gt;/g, '');
      note = note.replace(/lt;/g, '');
      note = note.replace(/ndash;/g, '');
      note = note.replace(/\\n/g, '');
      note = note.replace(/\n/g, '');
      note = note.replace(/(\r\n|\n|\r)/gm,"");
      note = note.replace(/\s\s+/g, ' ');
      note = note.trim();

      item.note = note
    }
    if (typeof item.additionalinfo === 'string' && item.additionalinfo.length > 0 && item.additionalinfo !== null) {
      // Remove formatting for additionalinfo
      let addInfo = item.additionalinfo;

      addInfo = addInfo.replace(/<\/?[^>]+(>|$)/g, '');
      addInfo = addInfo.replace(/nbsp;/g, '');
      addInfo = addInfo.replace(/amp;nbsp;/g, '');
      addInfo = addInfo.replace(/amp;ndash;/g, '');
      addInfo = addInfo.replace(/amp;gt;/g, '');
      addInfo = addInfo.replace(/amp;lt;/g, '');
      addInfo = addInfo.replace(/gt;/g, '');
      addInfo = addInfo.replace(/lt;/g, '');
      addInfo = addInfo.replace(/ndash;/g, '');
      addInfo = addInfo.replace(/\\n/g, '');
      addInfo = addInfo.replace(/\n/g, '');
      addInfo = addInfo.replace(/(\r\n|\n|\r)/gm,"");
      addInfo = addInfo.replace(/\s\s+/g, ' ');
      addInfo = addInfo.trim();

      item.additionalinfo = addInfo
    }
    data.thirdPartyNoteTitle = item.note
    data.thirdPartyNoteId = item.id
    data.thirdPartyNoteAI = item.additionalinfo
    data.thirdPartyNoteCreatedAt = formatTimestampByLocale(item.time)
    data.thirdPartyNoteCreatedBy = item.name
    sendNoteToThirdParty();
  }
  else if(item.type === 'task'){

    for(let x in data.timelineData){
      if(data.timelineData[x].dialogTask === true){
        data.timelineData[x].dialogTask = false
      }
    }
    data.thirdPartyTask = item.name
    data.thirdPartyTaskInfo = item.additionalinfo

    if(item.name === 'Complete Inspection'){
      data.thirdPartyTaskInfo = 'Inspection Completed'

    }
    data.thirdPartyTaskId = item.id
    data.thirdPartyTaskCreatedAt = formatTimestampByLocale(item.time)
    item.dialogTask = true
    let tmp = data.selectedFilters
    data.selectedFilters = ['note']
    data.selectedFilters = tmp
  }
  else if(item.type === 'message'){

    data.thirdPartyMessage = item.message
    data.thirdPartyMessageSentTo = item.recipientName
    data.thirdPartyMessageSentFrom = item.name
    data.thirdPartyMessageId = item.id
    data.thirdPartyMessageCreatedAt = formatTimestampByLocale(item.time)
    let tmp = data.selectedFilters
    data.selectedFilters = ['note']
    data.selectedFilters = tmp
    sendMessageToThirdParty();
  }
}

const sendMessageToThirdParty = () => {
  ApiWrapper.post('timeline', `send-message-to-${data.thirdPartyName.toLowerCase()}`, {
        message: data.thirdPartyMessage,
        sentTo: data.thirdPartyMessageSentTo,
        sentFrom: data.thirdPartyMessageSentFrom,
        sentAt: data.thirdPartyMessageCreatedAt,
        messageId: data.thirdPartyMessageId,
        claimId: props.contextIdA
      })
      .then((response) => {
        activeComponentStore.notifyComponents(['notes'],compName);
        loadData()
        ToastUtil.successMsg(`Sent to ${data.thirdPartyName}`);
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
}

const sendNoteToThirdParty = () => {
  ApiWrapper.post('timeline', `send-note-to-${data.thirdPartyName.toLowerCase()}`, {
        note: data.thirdPartyNoteTitle,
        info: data.thirdPartyNoteAI,
        noteId: data.thirdPartyNoteId,
        createdAt: data.thirdPartyNoteCreatedAt,
        createdBy: data.thirdPartyNoteCreatedBy,
        claimId: props.contextIdA
      })
      .then((response) => {
        // activeComponentStore.notifyComponents(['notes'],compName);
        activeComponentStore.notifyComponents(['notes'],compName);
        loadData()
        ToastUtil.successMsg(`Sent to ${data.thirdPartyName}`);
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
}

const sendTaskToThirdParty = () => {
  ApiWrapper.post('timeline', `send-task-to-${data.thirdPartyName.toLowerCase()}`, {
        task: data.thirdPartyTask,
        info: data.thirdPartyTaskInfo,
        taskId: data.thirdPartyTaskId,
        claimId: props.contextIdA
      })
      .then((response) => {
        activeComponentStore.notifyComponents(['notes'],compName);
        loadData()
        ToastUtil.successMsg(`Sent to ${data.thirdPartyName}`);
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
}

const deleteItem = (item) =>  {
  let deleteNote = confirm(
      'Are you sure you want to delete this item?'
  )
  if (deleteNote === true) {
    item.isDeleting = true
    ApiWrapper.post('notes', 'delete-note', {
          item: item,
          claimId: props.contextIdA
        })
        .then((response) => {
          activeComponentStore.notifyComponents(['notes'],compName);
          loadData()
          ToastUtil.successMsg('Deleted note');
        })
        .catch((err) => {
          ToastUtil.error(err);
        })
  }
}

const sendToClientRep = (item) =>  {
  let noteid = item.id
  let time = formatTimestampByLocale(item.time)
  ApiWrapper.post('timeline', 'send-note-as-email-to-client-rep', {
        noteid: noteid,
        time: time,
        claimId: props.contextIdA
      })
      .then((response) => {
        activeComponentStore.notifyComponents(['notes'],compName);
        loadData()
        ToastUtil.successMsg('Sending email to client rep');
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
}

const sendMessageToClientRep = (item) =>  {
  let time = formatTimestampByLocale(item.time)
  ApiWrapper.post('timeline', 'send-message-as-email-to-client-rep', {
        message: item.message,
        sentTo: item.recipientName,
        sentFrom: item.name,
        sentAt: time,
        messageId: item.id,
        claimId: props.contextIdA
      })
      .then((response) => {
        activeComponentStore.notifyComponents(['notes'],compName);
        loadData()
        ToastUtil.successMsg('Sending email to client rep');
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
}

const sendTaskToClientRep = (item) =>  {
  for(let x in data.timelineData){
    if(data.timelineData[x].dialogTaskClientRep === true){
      data.timelineData[x].dialogTaskClientRep = false
    }
  }

  if(item.name === 'Complete Inspection'){
    data.clientTaskInfo = 'Inspection Completed'
  }else{
    data.clientTaskInfo = item.additionalinfo
  }
  data.clientTask = item.name
  data.clientTaskId = item.id
  data.clientTaskCreatedAt = formatTimestampByLocale(item.time)
  item.dialogTaskClientRep = true
  let tmp = data.selectedFilters
  data.selectedFilters = ['note']
  data.selectedFilters = tmp
}

const finalizeTaskToClientRep = () => {
  ApiWrapper.post('timeline', 'send-task-as-email-to-client-rep', {
        task: data.clientTask,
        info: data.clientTaskInfo,
        id: data.clientTaskId,
        time: data.clientTaskCreatedAt,
        claimId: props.contextIdA
      })
      .then((response) => {
        activeComponentStore.notifyComponents(['notes'],compName);
        loadData()
        ToastUtil.successMsg('Sending email to client rep');
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
}

const formatTimestampByLocale = (timestamp) =>  {
  const date = new Date(timestamp)
  const timeOptions = {
    hour12: true,
    hour: "numeric",
    minute: "2-digit",
  }
  const dateOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZoneName:'short'
  }
  return date.toLocaleString('en', { ...dateOptions, ...timeOptions })
}

const submitEditedNote = (item) =>  {
  data.loadingButton = true
  ApiWrapper.post('notes', 'edit-note', {
        editedItem: item
      })
      .then((response) => {
        item.isEditing = false
        data.loadingButton = false
        loadData()
        ToastUtil.successMsg('Updating note');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loadingButton = false;
      })
}

const submitMessage = (item) =>  {
  data.loading = true
  ApiWrapper.post('messaging', 'create-reply', {
        claimId: props.contextIdA,
        message: item.newMessage,
        oldmessageid: item.id,
        name: item.name,
      })
      .then((response) => {
        loadData()
        item.newMessage = ''
        ToastUtil.successMsg('Replied to message');
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
      .finally(()=>{
        data.loading = false
      });
}

const updateMessage = (item) =>  {
  data.loading = true
  item.is_read = true
  ApiWrapper.post('messaging', 'update-message', {
        id: item.mid,
        status: true,
      })
      .then((response) => {
        loadData()
        ToastUtil.successMsg('Updated message');
      })
      .catch((err) => {
        ToastUtil.error(err);
      })
      .finally(()=>{
        data.loading = false
      })
}

const grabThumbnail = (item) =>  {
  if (item !== null && item !== '') {
    return 'data:image/jpeg;base64,' + item
  }
}

const loadData = () =>  {
  data.loading = true
  ApiWrapper.post('timeline', 'timeline', {
        method: 'loadData',
        claimId: props.contextIdA
      })
      .then((response) => {
          data.currentUser = response.curUser;
          data.xactid = response.xactId;
          data.symbilityid = response.symbilityId;

          if(data.xactid !== null) {
            data.thirdPartyName = 'Xact';
          }
          else if(data.symbilityid !== null) {
            data.thirdPartyName = 'Symbility';
          }
          else {
            data.thirdPartyName = '';
          }

          let timelineElement
          data.timelineData = []
          for (let i = 0; i < response.result.length; i++) {
            switch (response.result[i].type) {
              case 'file':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  key: response.result[i].key,
                  title: response.result[i].body.title,
                  id: response.result[i].id,
                  awsKey: response.result[i].body.awsKey,
                  smallthumbnail: response.result[i].body.smallthumbnail,
                  mediumthumbnail: response.result[i].body.mediumthumbnail,
                  uploadedBy: response.result[i].body.uploadedBy
                }
                break
              case 'note':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  key: response.result[i].key,
                  id: response.result[i].id,
                  isEditing: false,
                  note: response.result[i].body.note,
                  additionalinfo: response.result[i].body.additionalinfo,
                  clientDate: response.result[i].body.clientdate,
                  xactDate: response.result[i].body.xactdate,
                  thirdPartyDate: response.result[i].body.thirdpartydate,
                  claimnumber: response.result[i].body.claimnumber,
                }
                break
              case 'message':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  id: response.result[i].id,
                  recipient: response.result[i].body.recipient,
                  recipientName: response.result[i].body.name,
                  is_read: response.result[i].body.is_read,
                  replyToMessage: false,
                  xactDate: response.result[i].body.xactdate,
                  thirdPartyDate: response.result[i].body.thirdpartydate,
                  clientDate: response.result[i].body.clientdate,
                  mid: response.result[i].body.mid,
                  key: response.result[i].key,
                  pid: response.result[i].body.pid,
                  message: response.result[i].body.message,
                }
                break
              case 'interaction':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  id: response.result[i].id,
                  claimcontact: response.result[i].body.claimcontact,
                  clientcontact: response.result[i].body.clientcontact,
                  interaction: response.result[i].body.interaction,
                  key: response.result[i].key,
                }
                break
              case 'history':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  key: response.result[i].key,
                  id: response.result[i].id,
                  log: response.result[i].body.log,
                  //username: response.result[i].body.username,
                  username: response.result[i].body.personname,
                  timestamp: response.result[i].body.timestamp,
                }
                break
              case 'task':
                timelineElement = {
                  name: response.result[i].name,
                  time: response.result[i].time,
                  type: response.result[i].type,
                  key: response.result[i].key,
                  clientDate: response.result[i].body.clientdate,
                  xactDate: response.result[i].body.xactdate,
                  thirdPartyDate: response.result[i].body.thirdpartydate,
                  id: response.result[i].id,
                  createdBy: response.result[i].body.createdBy,
                  additionalinfo: '',
                }
                switch (response.result[i].name) {
                  case 'Complete Inspection':
                    timelineElement.additionalinfo =
                        `Appointment completed at ` +
                        formatTimestampByLocale(response.result[i].body.formdata.datetime)
                    break
                  case 'Make Contact':
                    if(response.result[i].body.contactOutcome === 'No, left voicemail'){
                      timelineElement.additionalinfo =
                          `Voicemail left by ` +
                          (response.result[i].body.createdBy !== null ? response.result[i].body.createdBy : response.result[i].body.adjuster) +
                          ` at  ` + formatTimestampByLocale(response.result[i].time)
                    }else if(response.result[i].body.contactOutcome === 'No answer'){
                      timelineElement.additionalinfo =
                          (response.result[i].body.createdBy !== null ? response.result[i].body.createdBy : response.result[i].body.adjuster) +
                          ` called and received no answer at  ` + formatTimestampByLocale(response.result[i].time)
                    }else{
                      timelineElement.additionalinfo =
                          `Appointment set by ` +
                          response.result[i].body.createdBy +
                          ` to meet with ` +
                          response.result[i].body.persontomeet +
                          ` on  ` + formatTimestampByLocale(response.result[i].body.datetime)
                    }
                    break
                  case 'Recontact':
                    if(response.result[i].body.contactOutcome === 'No, left voicemail'){
                      timelineElement.additionalinfo =
                          `Voicemail left by ` +
                          (response.result[i].body.createdBy !== null ? response.result[i].body.createdBy : response.result[i].body.adjuster) +
                          ` at  ` + formatTimestampByLocale(response.result[i].time)
                    }else if(response.result[i].body.contactOutcome === 'No answer'){
                      timelineElement.additionalinfo =
                          (response.result[i].body.createdBy !== null ? response.result[i].body.createdBy : response.result[i].body.adjuster) +
                          ` called and received no answer at  ` + formatTimestampByLocale(response.result[i].time)
                    }else{
                      timelineElement.additionalinfo =
                          `Appointment set by ` +
                          response.result[i].body.createdBy +
                          ` to meet with ` +
                          response.result[i].body.persontomeet +
                          ` on  ` + formatTimestampByLocale(response.result[i].body.datetime)
                    }
                    break
                }
                break
            }
            data.timelineData.push(timelineElement)
          }

          for(let x in data.timelineData){
            let cur = data.timelineData[x]

            if(cur.type === 'message'){
              let curMessage = cur.message
              let curDate = new Date(cur.time)
              data.timelineData[x].messageRecipients = []
              data.timelineData[x].messageIDs = []
              data.timelineData[x].isReadArr = []


              for(let y in data.timelineData){
                if(data.timelineData[y].type === 'message'){
                  let nextDate = new Date(data.timelineData[y].time)
                  if(data.timelineData[y].message === curMessage && Math.abs(curDate - nextDate) < 2500){
                    data.timelineData[x].messageRecipients.push(data.timelineData[y].recipient)
                    data.timelineData[x].messageIDs.push(data.timelineData[y].id)
                    data.timelineData[x].isReadArr.push(data.timelineData[y].is_read)

                    /**
                      Make sure we keep track of xactDate, thirdPartyDate, and clientDate for message with multiple recipients.
                      Since there will be duplicate message entries in the database, but only one is updated with client/xact/thirdParty dates, and only one is shown in the timeline.
                      This insures they all have the same dates
                    **/
                    if(data.timelineData[y].xactDate !== null && data.timelineData[x].xactDate === null) {
                      data.timelineData[x].xactDate = data.timelineData[y].xactDate;
                    }
                    if(data.timelineData[y].thirdPartyDate !== null && data.timelineData[x].thirdPartyDate === null) {
                      data.timelineData[x].thirdPartyDate = data.timelineData[y].thirdPartyDate;
                    }
                    if(data.timelineData[y].clientDate !== null && data.timelineData[x].clientDate === null) {
                      data.timelineData[x].clientDate = data.timelineData[y].clientDate;
                    }
                  }
                }
              }
            }
          }

          for(let j = data.timelineData.length - 1; j >= 0; j--){
            if(data.timelineData[parseInt(j)].type === 'message'){
              let curDate = new Date(data.timelineData[j].time)
              if(data.timelineData[parseInt(j) - 1] !== undefined){
                if(data.timelineData[parseInt(j) - 1].type === 'message'){
                  let nextDate = new Date(data.timelineData[parseInt(j) - 1].time)
                  if(data.timelineData[parseInt(j) - 1].message === data.timelineData[parseInt(j)].message && Math.abs(curDate - nextDate) < 2500){
                    data.timelineData.splice(parseInt(j), 1)
                  }
                }
              }
            }
          }

          for(let x in data.timelineData){
            if(data.timelineData[x].type === 'message'){
              if(data.timelineData[x].messageRecipients.includes(data.currentUser)){
                data.timelineData[x].permissions = true
                let index = data.timelineData[x].messageRecipients.indexOf(data.currentUser)
                data.timelineData[x].id = data.timelineData[x].messageIDs[index]
                data.timelineData[x].mid = data.timelineData[x].messageIDs[index]
                if(data.timelineData[x].isReadArr[index] === false){
                  data.timelineData[x].is_read = false
                }

              }
            }
          }

      })
      .catch((err) => {
        ToastUtil.error(err);
      })
      .finally(()=>{
        data.loading = false;
      });
}

const condense = () =>  {
  for (let x in data.notes) {
    data.notes[x].type = 'note'
    data.timelineData.push(data.notes[x])
  }
  for (let x in data.generic) {
    data.generic[x].type = 'generic'
    data.timelineData.push(data.generic[x])
  }
  for (let x in data.messages) {
    data.messages[x].type = 'message'
    data.timelineData.push(data.messages[x])
  }

  for (let x in data.uploads) {
    data.uploads[x].type = 'upload'
    data.timelineData.push(data.uploads[x])
  }
  for (let x in data.tasks) {
    data.tasks[x].type = 'task'
    data.timelineData.push(data.tasks[x])
  }
  for (let x in data.history) {
    data.tasks[x].type = 'history'
    data.timelineData.push(data.history[x])
  }
}

const checkboxFilter = (type) =>  {
  if (data.selectedFilters.indexOf(type) === -1) {
    data.selectedFilters.push(type)
  } else {
    data.selectedFilters.splice(data.selectedFilters.indexOf(type), 1)
  }
}

const downloadFile  = (item) =>  {
  // ApiWrapper.post('timeline', {
  //   key: item.awsKey,
  //   method: 'downloadFile'
  // }).then((response) => {
  //   window.open(response.url, "_blank");
  // }).catch((error) => {
  //    ToastUtil.error(e);
  // });
}

const downloadLegacyFile  = (item) =>  {
  // ApiWrapper.post('timeline', {
  //   id: item.id,
  //   method: 'downloadLegacyFile'
  // }).then((response) => {
  //   window.open(response.url, "_blank");
  // }).catch((error) => {
  //    ToastUtil.error(e);
  // })
}

const toggleActive = (index) =>  {
  if (data.show.includes(index)) {
    data.show = data.show.filter((entry) => entry !== index)
    return
  }
  data.show.push(index)
}

// const wrapSrcdocPage = (srcdoc) =>  {
//   //TODO: Figure out the issue with escaping this HTML return
//   return "";
//   // return `
//   //             <html>
//   //               <head>
//   //                 <link
//   //                   href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900"
//   //                   rel="stylesheet"
//   //                 />
//   //                 <meta
//   //                   name="viewport"
//   //                   content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui"
//   //                 />
//   //                 <style type="text/css">
//   //                   .v-application--wrap {
//   //                     min-height: 0;
//   //                   }
//   //
//   //                   body {
//   //                     font-family: 'Roboto', sans-serif;
//   //                   }
//   //                 </style>
//   //               </head>
//   //             <body>
//   //               <div>
//   //                 ${srcdoc}
//   //               </div>
//   //               <script src="https://cdn.jsdelivr.net/npm/iframe-resizer@4.3.2/js/iframeResizer.contentWindow.min.js"><\/script>
//   //             </body>
//   //             </html>
//   //           `
// }

const wrapSrcdocPage = (srcdoc) => {
  /* eslint-disable no-useless-escape */
  return `
              <html>
                <head>
                  <link
                    href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900"
                    rel="stylesheet"
                  />
                  <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui"
                  />
                  <style type="text/css">
                    .v-application--wrap {
                      min-height: 0;
                    }

                    body {
                      font-family: 'Roboto', sans-serif;
                    }
                  </style>
                </head>
              <body>
                <div>
                  ${srcdoc}
                </div>
                <script src="https://cdn.jsdelivr.net/npm/iframe-resizer@4.3.2/js/iframeResizer.contentWindow.min.js"><\/script>
              </body>
              </html>
            `
}

const toDataURL = (url, callback) =>  {
  let xhr = new XMLHttpRequest();
  xhr.onload = function() {
    let reader = new FileReader();
    reader.onloadend = function() {
      callback(reader.result);
    }
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

const downloadAllNotes = (items) =>  {
  let doc = new PDFDocument({ margin: 25 })
  let stream = doc.pipe(blobStream())

  doc
      .font('Times-Bold')
      .fontSize(20)
      .text('Notes', 80, 25)

  let c = document.createElement('canvas');
  let img = document.getElementById('tux');
  c.height = img.naturalHeight;
  c.width = img.naturalWidth;
  let ctx = c.getContext('2d');

  ctx.drawImage(img, 0, 0, c.width, c.height);
  let base64String = c.toDataURL();

  doc.image(base64String, 25, 10, {width: 50})

  function stripHtml(html)  {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  doc.moveTo(25, 75).lineTo(587, 75).stroke()
  doc.moveDown();

  let claimNumberNotes = []

  for (let item in items) {
    if (items[item].type === 'note') {
      claimNumberNotes.push(items[item].claimnumber)
      doc.moveDown();
      doc.font('Times-Bold').fontSize(12).text(items[item].name + ' created a note - ' + formatTimestampByLocale(items[item].time))
      doc.moveDown();
      doc
          .font('Times-Bold')
          .fontSize(12)
          .text('Note:')
      doc.moveDown();
      doc
          .font('Times-Roman')
          .fontSize(12)
          .text(stripHtml(items[item].note))
      doc.moveDown();

      if (typeof items[item].additionalinfo === 'string' && items[item].additionalinfo.length > 0 && items[item].additionalinfo !== null) {
        doc
            .font('Times-Bold')
            .fontSize(12)
            .text('Additional Info:')
        doc.moveDown();

        doc
            .font('Times-Roman')
            .fontSize(12)
            .text(stripHtml(items[item].additionalinfo))
        doc.moveDown();
      }
      doc
          .font('Times-Bold')
          .fontSize(12)
          .text('________________________________')
      doc.moveDown();
    }
  }

  doc.end()

  claimNumberNotes.splice(1);

  let blob
  stream.on('finish', function () {
    blob = stream.toBlob('application/pdf')
    if (!blob) return
    let url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = 'Note(s) - ' + claimNumberNotes
    a.click()
    window.URL.revokeObjectURL(url)
  })
}

const download = (item) =>  {
  let doc = new PDFDocument({ margin: 25 })
  let stream = doc.pipe(blobStream())

  doc
      .font('Times-Bold')
      .fontSize(20)
      .text('Note', 80, 25)

  let c = document.createElement('canvas');
  let img = document.getElementById('tux');
  c.height = img.naturalHeight;
  c.width = img.naturalWidth;
  let ctx = c.getContext('2d');

  ctx.drawImage(img, 0, 0, c.width, c.height);
  let base64String = c.toDataURL();

  doc.image(base64String, 25, 10, {width: 50})

  function stripHtml(html)  {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  doc.moveTo(25, 75).lineTo(587, 75).stroke()
  doc.moveDown();

  doc.moveDown();
  doc.font('Times-Bold').fontSize(12).text(item.name + ' created a note - ' + formatTimestampByLocale(item.time))
  doc.moveDown();

  doc
      .font('Times-Bold')
      .fontSize(12)
      .text('Note:')
  doc.moveDown();
  doc
      .font('Times-Roman')
      .fontSize(12)
      .text(stripHtml(item.note))
  doc.moveDown();

  if (typeof item.additionalinfo === 'string' && item.additionalinfo.length > 0 && item.additionalinfo !== null) {
    doc
        .font('Times-Bold')
        .fontSize(12)
        .text('Additional Info:')
    doc.moveDown();
    doc
        .font('Times-Roman')
        .fontSize(12)
        .text(stripHtml(item.additionalinfo))
    doc.moveDown();
  }

  doc.end()

  let blob
  stream.on('finish', function () {
    blob = stream.toBlob('application/pdf')
    if (!blob) return
    let url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = 'Note - ' + item.claimnumber
    a.click()
    window.URL.revokeObjectURL(url)
  })
}

onMounted(()=>{

  activeComponentStore.registerComponent(
      compName,
      [
        'files',
        'notes',
        'tasks',
        'messages',
        'claimstatusupdate'
      ],
      loadData
  );

  loadData()
});

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});

const filteredItems = computed(() => {
  return data.timelineData.filter((item) => {
    return Array.isArray(data.selectedFilters) && ((data.selectedFilters.indexOf(item.type) !== -1) || (data.selectedFilters.length === 0) || (data.selectedFilters.length === 1 && data.selectedFilters[0] === ''));
  });
});

</script>

<template>
  <v-container>
    <v-toolbar-title>Admin Timeline</v-toolbar-title>
    <div>
      <v-progress-linear
          :active="data.loading"
          :indeterminate="data.loading"
          color="primary"
      ></v-progress-linear>
    </div>
    <div>
      <v-timeline density="compact" align-top v-if="!data.loading && filteredItems.length !== 0">
        <v-timeline-item
            size="small"
            v-for="(item, index) in filteredItems"
            :key="item.key"
            color="primary"
            class="w-100"
        >
          <!-- NOTES -->
          <v-card v-if="item.type==='note'" class="overflow-auto elevation-2 mr-4 w-100" density="compact">
            <div v-if="item.isEditing === false">
              <v-card-actions class="elevation-0 py-0 pr-1">
                <v-card-subtitle class="pb-0 pt-1">
                  {{item.name}} created a note - {{formatTimestampByLocale(item.time)}}
                </v-card-subtitle>
                <v-spacer></v-spacer>
                <v-icon size="x-small" icon="mdi-file-pdf-box" color="#A9A9A9" @click="download(item)"/>
              </v-card-actions>
              <p class="py-0 ml-4 mr-4 mb-0 font-weight-medium p__text">
<!--                <iframe sandbox="allow-scripts allow-same-origin" v-resize.quiet="{ log: true, checkOrigin: false }"  width="100%" frameborder="0" :srcdoc="wrapSrcdocPage(item.note)"></iframe>-->
                <span class="note-span" v-html="item.note"></span>
                <span>
                      <v-btn
                          variant="text"
                          class="primary--text ml-2"
                          size="x-small"
                          @click="toggleActive(index)"
                          v-if="item.additionalinfo !== null && item.additionalinfo.length > 0"
                      >
                        <v-icon left size="x-small"
                        >{{ data.show.includes(index) ? 'mdi-chevron-up' :
                            'mdi-chevron-down' }}</v-icon
                        >
                        More Notes
                      </v-btn>
                    </span>
              </p>
              <div class="pb-0 pl-4" v-show="data.show.includes(index)">
                <iframe sandbox="allow-scripts allow-same-origin" v-resize.quiet="{ log: true, checkOrigin: false }"  width="100%" height="auto" frameborder="0" :srcdoc="wrapSrcdocPage(item.additionalinfo)"></iframe>
              </div>
              <v-card-actions v-if="!data.loading" class="py-5 pr-0" >
                <v-list-item density="compact" width="100%">
                  <v-row
                  >
                    <v-col cols="6">
                      <!-- Xact specific -->
                      <template v-if="data.xactid !== null">
                        <a @click="sendToThirdParty(item)" v-if="Permissions.checkPermissions(['timeline.send']) && (item.xactDate === null || item.xactDate === 'null' || item.xactDate === '01/01/1970') " class="text-decoration-underline" style="font-size: 10px">Send To Xact</a>
                        <span v-if="!(item.xactDate === null || item.xactDate === 'null' || item.xactDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to Xact on: {{formatTimestampByLocale(item.xactDate)}}</span>
                      </template>

                      <!-- Third party that isn't xact -->
                      <template v-if="data.symbilityid !== null">
                        <a @click="sendToThirdParty(item)" v-if="Permissions.checkPermissions(['timeline.send']) && (item.thirdPartyDate === null || item.thirdPartyDate === 'null' || item.thirdPartyDate === '01/01/1970') " class="text-decoration-underline" style="font-size: 10px">Send To {{ data.thirdPartyName }}</a>
                        <span v-if="!(item.thirdPartyDate === null || item.thirdPartyDate === 'null' || item.thirdPartyDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to {{ data.thirdPartyName }} on: {{formatTimestampByLocale(item.thirdPartyDate)}}</span>
                      </template>

                      <a @click="sendToClientRep(item)" v-if="Permissions.checkPermissions(['timeline.send']) && (item.clientDate === null || item.clientDate === 'null' || item.clientDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding"> Send To Client Rep</a>
                      <span v-if="!(item.clientDate === null || item.clientDate === 'null' || item.clientDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to Client on: {{formatTimestampByLocale(item.clientDate)}}</span>
                    </v-col>

                    <v-col cols="6" align="right" v-if="Permissions.checkPermissions(['timeline.send'])">

                      <v-icon v-if="item.isDeleting !== true" size="x-small" icon="mdi-delete" color="#A9A9A9" @click="deleteItem(item)">

                      </v-icon>
                      <v-progress-circular
                          v-else
                          size="x-small"
                          :width="2"
                          color="error"
                          indeterminate
                      ></v-progress-circular>
                      <v-icon size="x-small" icon="mdi-pencil" color="#A9A9A9" v-if="Permissions.checkPermissions(['notes.update'])" class="mr-1" @click="item.isEditing = true; item.originalNote = item.note; item.originalAdditionalinfo = item.additionalinfo">

                      </v-icon>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-card-actions>
            </div>
            <div v-if="item.dialogNote === true && item.isEditing === false">
              <v-card-title class="text-h5 grey lighten-2">
                Send To {{ data.thirdPartyName }}
              </v-card-title>

              <v-card-text class="pt-5">
                Note: {{data.thirdPartyNoteTitle}}
              </v-card-text>
              <v-card-text>
                Additional Info: {{data.thirdPartyNoteAI}}
              </v-card-text>
              <v-card-text>
                Created By: {{data.thirdPartyNoteCreatedBy}}
              </v-card-text>
              <v-card-text>
                Created At: {{data.thirdPartyNoteCreatedAt}}
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    variant="text"
                    @click="item.dialogNote = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    variant="text"
                    @click="item.dialogNote = false"
                >
                  Send
                </v-btn>
              </v-card-actions>
            </div>
            <!-- Edit Note Form -->
            <div v-if="item.isEditing === true">
              <v-list-subheader class="ml-5">Edit Note</v-list-subheader>
              <div class="pa-2">
                <QuillEditor theme="snow" v-model:content="item.note" contentType="html" toolbar="essential" />
              </div>
              <v-list-subheader class="ml-5">Additional Info</v-list-subheader>
              <div class="pa-2">
                <QuillEditor theme="snow" v-model:content="item.additionalinfo" contentType="html" toolbar="essential" />
              </div>


              <v-card-actions class="pt-0">
                <v-btn
                    size="small"
                    variant="elevated"
                    class="error"
                    v-if="item.isEditing === true"
                    @click="item.isEditing = false; item.note = item.originalNote; item.additionalinfo = item.originalAdditionalinfo"
                >
                  Cancel
                </v-btn>
                <v-btn
                    size="small"
                    variant="elevated"
                    color="primary"
                    :loading="data.loadingButton"
                    :disabled="data.loadingButton"
                    @click="submitEditedNote(item)"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>

          <!-- MESSAGES -->
          <v-card
              v-if="item.type==='message'"
              class="overflow-auto elevation-2 mr-4 w-100"
              :color="data.currentUser === item.recipient && item.is_read === false ? '#E3F2FD' : '#fafafa'"
          >
            <v-card-subtitle class="pt-1 pb-0 bottom__padding">
              {{item.name}} sent a message to {{ item.messageRecipients.toString() }} -
              {{ formatTimestampByLocale(item.time) }}
            </v-card-subtitle>

            <p class="font-weight-medium mb-2 py-0 ml-4 mr-4 top__padding p__text">
              {{item.message}}
            </p>
            <v-card-actions class="py-0">

              <div class="py-0 pr-0" id="card__actions__padding" align="center" justify="end">
                <!-- Xact specific -->
                <template v-if="data.xactid !== null">
                  <a @click="sendToThirdParty(item)" v-if="Permissions.checkPermissions(['timeline.send']) && (item.xactDate === null || item.xactDate === 'null' || item.xactDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px">Send To Xact</a>
                  <span v-if="!(item.xactDate === null || item.xactDate === 'null' || item.xactDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to Xact on: {{formatTimestampByLocale(item.xactDate)}}</span>
                </template>

                <!-- Third party that isn't xact -->
                <template v-if="data.symbilityid !== null">
                  <a @click="sendToThirdParty(item)" v-if="Permissions.checkPermissions(['timeline.send']) && (item.thirdPartyDate === null || item.thirdPartyDate === 'null' || item.thirdPartyDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px">Send To {{ data.thirdPartyName }}</a>
                  <span v-if="!(item.thirdPartyDate === null || item.thirdPartyDate === 'null' || item.thirdPartyDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to {{ data.thirdPartyName }} on: {{formatTimestampByLocale(item.thirdPartyDate)}}</span>
                </template>

                <a @click="sendMessageToClientRep(item)" v-if="Permissions.checkPermissions(['timeline.send']) && (item.clientDate === null || item.clientDate === 'null' || item.clientDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding"> Send To Client Rep</a>
                <span v-if="!(item.clientDate === null || item.clientDate === 'null' || item.clientDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to Client on: {{formatTimestampByLocale(item.clientDate)}}</span>
              </div>

              <v-spacer></v-spacer>

              <div v-if="item.permissions" class="px-5">
                <v-btn
                    v-if="item.replyToMessage === false && Permissions.checkPermissions(['messages.create'])"
                    size="x-small"
                    variant="text"
                    class="primary--text"
                    @click="item.replyToMessage = true"
                >
                  Reply
                </v-btn>
              </div>

              <div v-if="item.permissions && item.is_read === false">
                <v-btn size="x-small" variant="text" @click="updateMessage(item)">
                  Mark as Read
                </v-btn>
              </div>

            </v-card-actions>
            <div v-if="item.isReadArr.includes(true)">
              <template v-for="(stat, index) in item.isReadArr" :key="index">
                <v-btn v-if="stat === true" size="x-small" variant="text" class="success--text">
                  Message Read By {{item.messageRecipients[index]}}
                </v-btn>
              </template>
            </div>

            <!-- Reply to message form -->
            <div v-if="item.replyToMessage === true">
              <v-card-actions>
                <v-textarea
                    prepend-inner-icon="mdi-pencil"
                    clearable
                    filled
                    label="Message"
                    v-model="item.newMessage"
                    auto-grow
                ></v-textarea>
              </v-card-actions>

              <v-card-actions>
                <v-btn
                    size="small"
                    variant="elevated"
                    class="error"
                    v-if="item.replyToMessage === true"
                    @click="item.replyToMessage = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    size="small"
                    variant="elevated"
                    class="primary"
                    v-if="item.replyToMessage === true"
                    :loading="data.loading"
                    @click="submitMessage(item)"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>

          <!-- INTERACTIONS -->
          <v-card
              v-if="item.type==='interaction'"
              class="elevation-2 mr-4 w-100"
          >
            <v-card-subtitle class="pb-0" v-if="item.clientcontact">
              {{item.name}} interacted with {{item.clientcontact}} -
              {{ formatTimestampByLocale(item.time) }}
            </v-card-subtitle>
            <v-card-subtitle class="pb-0" v-else>
              {{item.name}} interacted with {{item.claimcontact}} -
              {{ formatTimestampByLocale(item.time) }}
            </v-card-subtitle>
            <p class="pt-0 py-2 mb-0 ml-4 mr-4 font-weight-medium p__text">
              {{item.interaction}}
            </p>
          </v-card>

          <!-- HISTORY (Who closed/re-opened claim and when.) -->
          <v-card
              v-if="item.type==='history'"
              class="overflow-auto elevation-2 mr-4 w-100"
          >
            <div v-if="item.username">
              <v-card-subtitle class="pt-1 pb-0">
                {{ formatTimestampByLocale(item.timestamp) }}
              </v-card-subtitle>
              <v-card-title class="py-0">
                {{ item.log }} by {{ item.username }}
              </v-card-title>
            </div>
          </v-card>

          <!-- TASKS -->
          <v-card v-if="item.type==='task'" class="overflow-auto elevation-2 mr-4 w-100">
            <v-card-subtitle v-if="item.createdBy === null" class="pb-0 pt-1">
              {{item.name}} - {{ formatTimestampByLocale(item.time) }}
            </v-card-subtitle>
            <v-card-subtitle v-else class="pb-0 pt-1">
              {{item.createdBy}} - {{ formatTimestampByLocale(item.time) }}
            </v-card-subtitle>

            <p  v-if="item.name === 'Make Contact' || item.name === 'Recontact'" class="font-weight-medium pt-0 pb-2 ml-4 mr-4 mb-0 top__padding p__text">
              {{item.additionalinfo}}
            </p>

            <p  v-else class="font-weight-medium pt-0 pb-2 ml-4 mr-4 mb-0 top__padding p__text">
              {{item.name}} task completed.
              <span>
                    <v-btn
                        variant="text"
                        class="primary--text ml-2"
                        size="x-small"
                        @click="toggleActive(index)"
                        v-if="item.additionalinfo !== null && item.additionalinfo.length > 0"
                    >
                      <v-icon left size="x-small"
                      >{{ data.show.includes(index) ? 'mdi-chevron-up' :
                          'mdi-chevron-down' }}</v-icon
                      >
                      More Info
                    </v-btn>
                  </span>
            </p>
            <div class="px-4" v-show="data.show.includes(index)">
              <p class="pt-0 py-2 mb-0 ml-2 font-weight-medium p__text">
                {{item.additionalinfo}}
              </p>
            </div>
            <v-card-actions v-if="!data.loading" class="py-0 pr-0" id="card__actions__padding">
              <v-list-item density="compact">
                <v-row
                    align="center"
                    justify="end"
                >
                  <div>
                    <!-- Xact specific -->
                    <template v-if="data.xactid !== null">
                      <a v-if="Permissions.checkPermissions(['timeline.send']) && (item.xactDate === null || item.xactDate === 'null' || item.xactDate === '01/01/1970' )" @click="sendToThirdParty(item)" class="text-decoration-underline" style="font-size: 10px">Send To Xact</a>
                      <span v-if="!(item.xactDate === null || item.xactDate === 'null' || item.xactDate === '01/01/1970' )" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to Xact on: {{formatTimestampByLocale(item.xactDate)}}</span>
                    </template>

                    <!-- Third party that isn't xact -->
                    <template v-if="data.symbilityid !== null">
                      <a v-if="Permissions.checkPermissions(['timeline.send']) && (item.thirdPartyDate === null || item.thirdPartyDate === 'null' || item.thirdPartyDate === '01/01/1970' )" @click="sendToThirdParty(item)" class="text-decoration-underline" style="font-size: 10px">Send To {{ data.thirdPartyName }}</a>
                      <span v-if="!(item.thirdPartyDate === null || item.thirdPartyDate === 'null' || item.thirdPartyDate === '01/01/1970' )" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to {{ data.thirdPartyName }} on: {{formatTimestampByLocale(item.thirdPartyDate)}}</span>
                    </template>

                    <a v-if="Permissions.checkPermissions(['timeline.send']) && (item.clientDate === null || item.clientDate === 'null' || item.clientDate === '01/01/1970')" @click="sendTaskToClientRep(item)" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding"> Send To Client Rep</a>
                    <span v-if="!(item.clientDate === null || item.clientDate === 'null' || item.clientDate === '01/01/1970')" class="text-decoration-underline" style="font-size: 10px" id="a__text__padding">Sent to Client on: {{formatTimestampByLocale(item.clientDate)}}</span>
                  </div>
                  <v-spacer></v-spacer>
                </v-row>
              </v-list-item>
            </v-card-actions>
            <div v-if="item.dialogTask === true">
              <v-card-title>
                Send To {{ data.thirdPartyName }}
              </v-card-title>

              <!-- <v-text-field density="compact" v-model="thirdPartyTask"  label="Task Name"  class="mx-4"></v-text-field> -->

              <v-text-field density="compact" v-model="data.thirdPartyTaskInfo"  label="Task Info"  class="mx-4"></v-text-field>


              <!-- <v-card-text class="pt-5">
                Task: {{thirdPartyTask}}
              </v-card-text>
              <v-card-text>
                Additional Info: {{thirdPartyTaskInfo}}
              </v-card-text> -->
              <!-- <v-card-text>
                Completed At: {{thirdPartyTaskCreatedAt}}
              </v-card-text> -->

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    variant="text"
                    @click="item.dialogTask = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    variant="text"
                    @click="item.dialogTask = false; sendTaskToThirdParty()"
                >
                  Send
                </v-btn>
              </v-card-actions>
            </div>
            <div v-if="item.dialogTaskClientRep === true">
              <v-card-title>
                Send To Client Rep
              </v-card-title>

              <!-- <v-text-field density="compact" v-model="clientTask"  label="Task Name"  class="mx-4"></v-text-field> -->

              <v-text-field density="compact" v-model="data.clientTaskInfo"  label="Task Info"  class="mx-4"></v-text-field>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    variant="text"
                    @click="item.dialogTaskClientRep = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    variant="text"
                    @click="item.dialogTaskClientRep = false; finalizeTaskToClientRep()"
                >
                  Send
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>

        </v-timeline-item>
      </v-timeline>
      <v-timeline v-else>
        <v-timeline-item size="x-small">
          No Data
        </v-timeline-item>
      </v-timeline>
    </div>
    <img id="tux"
         crossOrigin="anonymous"
         src="/images/aanew.jpg"
         style="display: none"
         alt=""
    />
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }

  [v-cloak] {
    display: none;
  }
  .v-list-item-subtitle {
    font-size: 10px !important;
    color: black !important;
  }

  /* .v-input .v-label {
    font-size: 13px !important;
  } */

  .v-card-subtitle {
    font-size: 10px !important;
    color: black !important;
    text-wrap: wrap!important;
  }
  .v-card-title {
    font-size: 13px !important;
    color: black !important;
    text-wrap: wrap!important;
  }

  #bottom__padding {
    padding-bottom: 0 !important;
  }
  #top__padding {
    padding-top: 0 !important;
  }
  .p__text {
    font-size: 13px !important;
    color: black !important;
    font-family: Roboto, sans-serif;
  }
  #a__text__padding {
    padding-left: 8px !important;
  }
  #card__actions__padding {
    padding-left: 13px !important;
    height: 20px !important;
  }
  .note-span{
    display: inline-block;
  }
</style>